// Monogram serif "S" institutional brand mark for Salnés Sostible / Salnés Sostenible
import { useTranslation } from "react-i18next";

export default function BrandMark({ size = 36, tone = "atlantic" }) {
  const { t } = useTranslation();
  const colors = {
    atlantic: { bg: "#0B4C7A", fg: "#FBFAF7" },
    ivory: { bg: "#FBFAF7", fg: "#0B4C7A" },
  }[tone] || { bg: "#0B4C7A", fg: "#FBFAF7" };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={t("brand.name")}
    >
      <rect x="0" y="0" width="64" height="64" rx="10" fill={colors.bg} />
      <path
        d="M46 22c-3-3-7-4.5-12-4.5-6 0-11 3.5-11 8.5 0 4.5 3.5 6.5 10 8 6 1.5 8 2.5 8 5 0 2.5-3 4-6.5 4-4 0-7-1.5-9.5-4l-3 3.5c3.5 3.5 8 5.5 12.5 5.5 7 0 12-3.5 12-9 0-5-3.5-7-11-8.5-6-1.5-7-2.5-7-4.5 0-2 2.5-3.5 6-3.5 3 0 6 1 8.5 3l3-3z"
        fill={colors.fg}
      />
      <circle cx="12" cy="52" r="2" fill="#10B981" />
    </svg>
  );
}
